import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import TableSimpleView from "../tables/TableSImple";

function rand() {
    return Math.round(Math.random() * 20) - 10;
}

function getModalStyle() {
    const top = 50 + rand();
    const left = 50 + rand();

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        width: 400,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));

export default ({entity,title,data,open,onClose,includeHeader})=> {
    const classes = useStyles();
    const [modalStyle] = React.useState(getModalStyle);


    return (
        <div>
            <Modal
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                open={open}
                onClose={onClose}
            >
                <div style={modalStyle} className={classes.paper}>
                    <h2 id="simple-modal-title">{entity} &nbs; {title}</h2>
                    <TableSimpleView data={data} includeHeader={includeHeader}/>
                    <button onClick={()=>onClose()} style={{
                        float:"right",
                        backgroundColor:"black",
                        color:"white",
                        margin:10,
                        minWidth:50,
                        minHeight:35,
                        borderColor:"red",
                        borderWidth:1,
                        borderRadius:5,
                    }}>Close</button>
                </div>
            </Modal>
        </div>
    );
}
